import type Manifest from '~/types/Manifests';

import { ActionKeys } from '~/actions/constants';
import {
  type ManifestGeneratePayload,
  type ManifestGroups,
  type ManifestGroupsRequestPayload,
} from '~/types/Manifests';

export const fetchManifests = () =>
  <const>{
    type: ActionKeys.MANIFESTS_FETCH,
  };

export const fetchManifestsSuccess = (payload: Manifest[]) =>
  <const>{
    payload,
    type: ActionKeys.MANIFESTS_FETCH_SUCCESS,
  };

export const fetchManifestsSuccessTerminalState = (payload: Manifest[]) =>
  <const>{
    payload,
    type: ActionKeys.MANIFESTS_FETCH_SUCCESS_TERMINAL_STATE,
  };

export const fetchManifestsGroups = (payload: ManifestGroupsRequestPayload) =>
  <const>{
    payload,
    type: ActionKeys.MANIFESTS_GROUPS_FETCH,
  };

export const fetchManifestsGroupsSuccess = (payload: ManifestGroups) =>
  <const>{
    payload,
    type: ActionKeys.MANIFESTS_GROUPS_FETCH_SUCCESS,
  };

export const fetchManifestsGroupsError = (payload: Error) =>
  <const>{
    payload,
    type: ActionKeys.MANIFESTS_GROUPS_FETCH_ERROR,
  };

export const fetchManifestsError = (payload: Error) =>
  <const>{
    payload,
    type: ActionKeys.MANIFESTS_FETCH_ERROR,
  };

export const downloadManifestDocumentZip = (manifestID: number) =>
  <const>{
    payload: manifestID,
    type: ActionKeys.MANIFESTS_DOWNLOAD_ZIP,
  };

export const downloadManifestDocumentZipSuccess = () =>
  <const>{
    type: ActionKeys.MANIFESTS_DOWNLOAD_ZIP_SUCCESS,
  };

export const downloadManifestDocumentZipError = () =>
  <const>{
    type: ActionKeys.MANIFESTS_DOWNLOAD_ZIP_ERROR,
  };

// TODO: Type payload
export const updateManifestsAddress = (payload) =>
  <const>{
    payload,
    type: ActionKeys.MANIFESTS_UPDATE_ADDRESS,
  };

export const generateManifest = (payload: ManifestGeneratePayload) =>
  <const>{
    payload,
    type: ActionKeys.MANIFESTS_GENERATE,
  };

export const generateManifestSuccess = () =>
  <const>{
    type: ActionKeys.MANIFESTS_GENERATE_SUCCESS,
  };

export const generateManifestError = (payload: Error) =>
  <const>{
    payload,
    type: ActionKeys.MANIFESTS_GENERATE_ERROR,
  };

export const startManifestsPolling = (manifestsToPoll: string[]) =>
  <const>{
    payload: {
      manifestsToPoll,
    },
    type: ActionKeys.MANIFESTS_POLL_START,
  };

export const stopManifestsPolling = () =>
  <const>{
    type: ActionKeys.MANIFESTS_POLL_END,
  };

export type ManifestsActions =
  | ReturnType<typeof downloadManifestDocumentZip>
  | ReturnType<typeof downloadManifestDocumentZipError>
  | ReturnType<typeof downloadManifestDocumentZipSuccess>
  | ReturnType<typeof fetchManifests>
  | ReturnType<typeof fetchManifestsError>
  | ReturnType<typeof fetchManifestsGroups>
  | ReturnType<typeof fetchManifestsGroupsError>
  | ReturnType<typeof fetchManifestsGroupsSuccess>
  | ReturnType<typeof fetchManifestsSuccess>
  | ReturnType<typeof fetchManifestsSuccessTerminalState>
  | ReturnType<typeof generateManifest>
  | ReturnType<typeof generateManifestError>
  | ReturnType<typeof generateManifestSuccess>
  | ReturnType<typeof startManifestsPolling>
  | ReturnType<typeof stopManifestsPolling>
  | ReturnType<typeof updateManifestsAddress>;
